import { Component } from '@angular/core';
import { ToastController, AlertController, MenuController, LoadingController } from '@ionic/angular'
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';

import { BasePage } from '../base.page';
import { ThrowError } from 'projects/core/src/lib/core/ThrowError';
import { CadastroViewModel } from './CadastroViewModel';
import { CadastroModel } from 'projects/core/src/lib/core/model/CadastroModel';
import { AlertComponent } from 'projects/core/src/lib/core/Alert.component';
import { LoginViewModel } from '../login/LoginViewModel';
import { MaskCPF } from 'projects/core/src/lib/core/MaksCPF';
import { LoadingComponent } from 'projects/core/src/lib/core/Loading.component';
import { Browser } from '@capacitor/browser';

@Component({
    selector: 'cadastro-page',
    templateUrl: 'cadastro.page.html',
    styleUrls: ['cadastro.page.scss']
})
export class CadastroPage extends BasePage {
    constructor(
        public router: Router,
        private loadingController: LoadingController,
        public toastCtrl: ToastController,
        private navCtrl: NavController,
        public alertController: AlertController,
        public menuCtrl: MenuController) {
        super(router)
    }

    loadingComponent: LoadingComponent
    emRequisicao: Boolean = false
    cadastroViewModel: CadastroViewModel
    cadastroModel: CadastroModel
    alertComponent: AlertComponent
    loginViewModel: LoginViewModel
    urlTermos: string = "https://app.phicube.com.br/termos.pdf"
    urlPrivacidade: string = 'https://app.phicube.com.br/privacidade.pdf'

    ngOnInit() {
        this.inicializarVariaveis()
        this.menuCtrl.enable(false)
    }

    inicializarVariaveis() {
        this.cadastroModel = new CadastroModel()
        this.loadingComponent = new LoadingComponent(this.loadingController)
        this.cadastroViewModel = new CadastroViewModel()
        this.cadastroViewModel.setContext(this)
        this.loginViewModel = new LoginViewModel()
    }

    async enviaCadastro() {
        try {
            this.emRequisicao = true
            await this.cadastroViewModel.enviaCadastro(this.cadastroModel)
        } catch (e) {
            AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, ThrowError.MESSAGE_DEFAULT, () => {
                this.navCtrl.pop()
            })
        }
        setTimeout(() => {
            this.emRequisicao = false
        }, 1000)
    }

    formataCampoCpf() {
        this.cadastroModel.cpf = new MaskCPF().cpf_mask(this.cadastroModel.cpf)
    }

    clickLinkTermos() {
        this.abreLinkExterno(this.urlTermos)
    }

    clickLinkPoliticaPrivacidade() {
        this.abreLinkExterno(this.urlPrivacidade)
    }

    async abreLinkExterno(url: string) {
        await Browser.open({ url });
    }

    mensagemSucessoAlteracao(message: string) {
        this.loginViewModel.setupApp().then(() => {
            this.navCtrl.pop()
            window.location.reload()
        }).catch(() => {
            AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, ThrowError.MESSAGE_DEFAULT)
        })
    }

    mensagemFalhaAlteracao(message: string) {
        this.showToast(message)
    }

    validaFormulario(): Boolean {
        if (!this.cadastroModel.name || this.cadastroModel.name == '') {
            AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, 'É necessário preencher o campo "nome" para o cadastro')
            return false;
        }

        if (!this.cadastroModel.email || this.cadastroModel.email == '') {
            AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, 'É necessário preencher o campo "e-mail" para o cadastro')
            return false;
        }

        if (!this.cadastroViewModel.validateEmail(this.cadastroModel.email)) {
            AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, 'Informe um endereço de e-mail válido para o cadastro')
            return false;
        }

        if (!this.cadastroModel.cpf || this.cadastroModel.cpf == '') {
            AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, 'É necessário preencher o campo "cpf" para o cadastro')
            return false;
        }

        if (!this.cadastroModel.phone || this.cadastroModel.phone == '') {
            AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, 'É necessário preencher o campo "telefone" para o cadastro')
            return false;
        }

        if (!this.cadastroViewModel.validateCpf(this.cadastroModel.cpf)) {
            AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, 'Informe um número de CPF válido para o cadastro')
            return false;
        }

        if (!this.cadastroModel.password || this.cadastroModel.password == '') {
            AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, 'É necessário preencher o campo "senha" para o cadastro')
            return false;
        }

        if (!this.cadastroModel.passwordConfirm || this.cadastroModel.passwordConfirm == '') {
            AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, 'É necessário preencher o campo "confirmar senha" para o cadastro')
            return false;
        }

        if (this.cadastroModel.passwordConfirm != this.cadastroModel.password) {
            AlertComponent.showAlert(ThrowError.TITLE_DEFAULT, 'O campo "senha" deve ser igual ao campo "confirmar senha"')
            return false;
        }
        return true
    }

    btnCriarConta() {
        if (this.validaFormulario()) {
            this.enviaCadastro()
        }
    }

    btnPossuiConta() {
        this.openPage("/")
    }

    async showToast(message: string) {
        let toast = await this.toastCtrl.create({
            message,
            duration: 3000,
            position: 'top'
        });
        toast.present();
    }

    async showLoading() {
        return await this.loadingComponent.showLoading()
    }
}
